module.exports = __webpack_public_path__ + "img/chart.3d3cfdc9.png";